import React, { Component } from 'react';

import social from '@js/utility/social.json';

import instagram from '@images/icon-ig-white.svg';
import facebook from '@images/icon-fb-white.svg';

class SocialBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { socialBlockType } = this.props;
    const socialBlockContent = social[socialBlockType];
    return (
      <div className="social-block bg-primary py-5">
        <div className="container">
          <h3 className="social-block-title text-center text-white mb-4">追蹤我們</h3>
          <div className="row">
            {Object.keys(socialBlockContent).map((platform, index, array) => {
              const isLastItem = index === array.length - 1;
              const marginBottomClass = isLastItem ? '' : 'mb-4';
              return (
                <div key={platform} className={`col col-12 col-md-6 px-5 ${marginBottomClass}`}>
                  <a
                    href={socialBlockContent[platform].link}
                    className="d-flex align-items-center justify-content-center border border-white py-4"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="social-icon">
                      {platform === 'instagram' && (
                      <img src={instagram} alt="instagram" />
                      )}
                      {platform === 'facebook' && (
                      <img src={facebook} alt="facebook" />
                      )}
                    </div>
                    <div className="social-title">
                      <p className="text-white text-capitalize my-0 fs-5 mx-3 fst-italic">{platform}</p>
                    </div>
                  </a>
                  <div className="col col-12 mt-3 bg-white rounded">
                    <a
                      href={socialBlockContent[platform].link}
                      className={`${platform} btn d-flex justify-content-center align-items-center`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      立即追蹤
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="ms-2">
                        {' '}
                        <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                        {' '}
                      </svg>
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default SocialBlock;
